import axios from 'axios';
import { isToday } from 'date-fns';
import mixpanel from 'mixpanel-browser';
import { useCallback, useContext } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { CTAInteractionTrackingEvents, PageTitles } from '@revelio/core';

import { environment } from '../../environment';
import { SurfContext } from '../../surf-context';
import { ThemeHeading, ThemeTagline } from './theme/theme';
import { Button, Stack } from './ui';
import { useToast } from './ui/toast';

// Same contact-sales behaviour as the legacy page — only the rendering
// changed.
export function TrialExpiredCta() {
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const name = searchParams.get('name');
  const email = searchParams.get('email');
  const csrfToken = useContext(SurfContext);
  const location = useLocation();

  const mixpanelContactSales = () => {
    mixpanel.track(CTAInteractionTrackingEvents.CONTACT_SALES_CLICK, {
      days_left: 0,
      page: PageTitles.TRIAL_EXPIRED,
    });
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: mirrors the legacy page
  const handleContactSales = useCallback(async () => {
    if (name?.length && email?.length) {
      mixpanelContactSales();
      const contactedSales = localStorage.getItem('contacted-sales') || '';
      if (!contactedSales || !isToday(new Date(contactedSales))) {
        await axios.post(
          `${environment.PUBLIC_USER_MGMT_URL}/api/users/hubspot/contactsales`,
          { email, trialUpgrade: location.pathname },
          {
            headers: {
              'x-surf-token': csrfToken,
            },
            withCredentials: true,
          }
        );
        localStorage.setItem('contacted-sales', new Date().toDateString());
        toast({
          title: 'E-mail sent!',
          description:
            "We've sent an e-mail to both you and a member of our Sales Team to connect.",
        });
      } else {
        toast({
          title: 'Thank you!',
          description:
            'We’ve notified a member of our Sales Team, who will reach out shortly.',
        });
      }
    }
  }, [email, name, toast, csrfToken, location]);

  return (
    <Stack gap="var(--ap-cta-gap)" fullWidth>
      <Stack gap="12px">
        <ThemeHeading>Your trial expired</ThemeHeading>
        <ThemeTagline>
          Please reach out to sales to upgrade your account
        </ThemeTagline>
      </Stack>
      <Button onClick={handleContactSales}>Contact Sales</Button>
    </Stack>
  );
}
